import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';

import { Provider } from 'react-redux';
import { store } from './store';

import { App as AntApp, ConfigProvider } from 'antd';

import './index.less';

import App from './App';

import reportWebVitals from './reportWebVitals';

import Home from './Home';
import BoldPenguinQuotationComponent from './components/bold-penguin-quotation';
import NCRoamSubscriptionComponent from './components/nc-roam-subscription';
import ReminderNotificationPopupComponent, { ReminderNotificationPopupComponentProps } from './components/reminder-notification-popup';
import SMSesComponent from './components/smses';
import SupportChatComponent, { SupportChatComponentProps } from './components/support-chat';
import UnreadMessageComponent, { UnreadMessageComponentProps } from './components/unread-message';
import UserActivityEventsComponent from './components/user-activity-events';
import WebSocketComponent from './shared/components/web-socket';
import GuideAIAppHandlerComponent, { GuideAIAppHandlerComponentProps } from './components/guideai-app-handler';
import ESignDocumentsComponent, { ESignDocumentsComponentProps } from './components/rabbit-sign/components/esign-documents';
import SignatureComponent, { SignatureComponentProps } from './components/signature';
import SystemMessageEditComponent, { SystemMessageEditComponentProps } from './components/system-messages/edit-item';
import { NotesComponent, QuickNoteButton, CreateNoteFromFileModal } from './components/notes';

import { getThemeToken } from './shared/utils';

const themeToken = getThemeToken();

const rootElement = document.getElementById('nc-debug-root') as HTMLElement;

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  const unreadMessageComponentProps: any = {
    currentUserId: '9fd872aa-ab9b-4bab-bc54-80083145bcb8',
    agencyId: 'ceb70181-2bf2-4e52-8ba8-4e575fc0bb08',
    userType: 'InsuranceAgency',
  } as UnreadMessageComponentProps;

  const reminderNotificationPopupComponentProps: any = {
    userId: '058091d8-3a1d-49a6-b04b-9823053b7fcd',
    agencyId: 'ee8144aa-32c0-4f4c-8c5f-1e3136ed6fc9',
    databaseId: '18ae8d4b-f6ac-4976-b2c2-006667f7bd85',
    timeZoneId: 'FLE Standard Time',
  } as ReminderNotificationPopupComponentProps;

  const supportChatConfig: any = {
    userType: 2,
    trackingCompanyId: '92d27fd9-0fe8-4880-abc3-0343b870d173',
  } as SupportChatComponentProps;

  const guideAIAppHandlerConfig: any = {
    organizationKey: '',
  } as GuideAIAppHandlerComponentProps;

  const esignDocumnetsConfigProps: ESignDocumentsComponentProps = {
    //insuredId: '895DB7A9-11E1-4BB5-BF89-9E5E7E18B0E4',
    //insuredId: '41fb97a6-6284-439f-9c71-b07de27b68c1',
    insuredId: '00ff4313-94d7-43dd-9dc7-e2e8abc8fa30',
  };

  const signatureConfigProps: SignatureComponentProps = {
    signatureId: '5b5dddf9-2157-46df-a6e2-b07d8aaeb82b',
    truckingCompanyId: 'fa521c31-33df-4ae7-82dc-19473666202d',
    policyId: undefined,
    agentId: undefined,
    certificateHolderId: undefined,
    redirectUrl: undefined,
  };

  const systemMessageEditProps: SystemMessageEditComponentProps = {
    systemMessageId: undefined, //NEW system message
    //systemMessageId: '0bc073a6-b3aa-428a-9afb-041ea4afe59a'
  };

  const notesComponentProps: any = {
    insuredId: 'fa521c31-33df-4ae7-82dc-19473666202d',
    agencyId: 'ee8144aa-32c0-4f4c-8c5f-1e3136ed6fc9',
    // policyId: 'a4a0b8a5-c356-42e3-8895-0990b3142897',
    policyId: '',
    taskId: '',
    agentId: '',
    ownerType: 0, // insured
    // ownerType: 3, // policy
    //isHistoryNotes: true
  };

  if (root) {
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <ConfigProvider theme={themeToken} getPopupContainer={() => rootElement}>
            <AntApp>
              <Provider store={store}>
                <Routes>
                  <Route element={<App />}>
                    <Route index element={<Home />} />
                    <Route path="bold-penguin-quotation" element={<BoldPenguinQuotationComponent />} />
                    <Route path="nc-roam-subscription" element={<NCRoamSubscriptionComponent />} />
                    <Route
                      path="web-socket"
                      element={
                        <React.Fragment>
                          <WebSocketComponent key="websocket" />
                          <UnreadMessageComponent key="unread-message" {...unreadMessageComponentProps} />
                          <ReminderNotificationPopupComponent key="reminder-notification-popup" {...reminderNotificationPopupComponentProps} />
                        </React.Fragment>
                      }
                    />
                    <Route path="user-activity-events" element={<UserActivityEventsComponent />} />
                    <Route
                      path="smses"
                      element={
                        <React.Fragment>
                          <WebSocketComponent key="websocket" />
                          <UnreadMessageComponent key="unread-message" {...unreadMessageComponentProps} />
                          <SMSesComponent key="smses" />
                        </React.Fragment>
                      }
                    />
                    <Route path="support-chat" element={<SupportChatComponent {...supportChatConfig} />} />
                    <Route path="guideai-app-handler" element={<GuideAIAppHandlerComponent {...guideAIAppHandlerConfig} />} />
                    <Route path="esign-documents" element={<ESignDocumentsComponent {...esignDocumnetsConfigProps} />} />
                    <Route path="signature" element={<SignatureComponent {...signatureConfigProps} />} />
                    <Route path="system-message-edit" element={<SystemMessageEditComponent {...systemMessageEditProps} />} />
                    <Route path="notes" element={<NotesComponent {...notesComponentProps} />} />
                    <Route path="quick-note" element={<QuickNoteButton {...notesComponentProps} />} />
                  </Route>
                </Routes>
              </Provider>
            </AntApp>
          </ConfigProvider>
        </BrowserRouter>
      </React.StrictMode>,
    );
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const lazyLoadNCRoamSubscription = () => {
  const element = document.getElementById('nc-roam-subscription-root-lazy');

  if (element) {
    const subscriptionRoot = ReactDOM.createRoot(element as HTMLElement);

    if (subscriptionRoot) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <NCRoamSubscriptionComponent />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      subscriptionRoot.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_NC_ROAM_SUBSCRIPTION', lazyLoadNCRoamSubscription, false);

const lazyLoadBoldPenguinQuotation = () => {
  const element = document.getElementById('bold-penguin-quotation-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <BoldPenguinQuotationComponent />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_BOLD_PENGUIN_QUOTATION', lazyLoadBoldPenguinQuotation, false);

const lazyLoadUnreadMessage = (event: any) => {
  const element = document.getElementById('unread-message-root-lazy');

  const unreadMessageConfig: any = event.detail;

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <UnreadMessageComponent {...unreadMessageConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_UNREAD_MESSAGE', lazyLoadUnreadMessage, false);

const lazyLoadWebSocket = () => {
  const element = document.getElementById('web-socket-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <WebSocketComponent />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_WEB_SOCKET', lazyLoadWebSocket, false);

const lazyLoadReminderNotificationsPopup = (event: any) => {
  const element = document.getElementById('reminder-notification-popup-root-lazy');

  const reminderNotificationPopupConfig: any = event.detail;

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <ReminderNotificationPopupComponent {...reminderNotificationPopupConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_REMINDER_NOTIFICATION_POPUP', lazyLoadReminderNotificationsPopup, false);

const lazyLoadUserActivityEvents = () => {
  const element = document.getElementById('user-activity-events-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <UserActivityEventsComponent />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_USER_ACTIVITY_EVENTS', lazyLoadUserActivityEvents, false);

const lazyLoadSupportChat = (event: any) => {
  const element = document.getElementById('support-chat-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const supportChatConfig: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <SupportChatComponent {...supportChatConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_SUPPORT_CHAT', lazyLoadSupportChat, false);

const lazyLoadSMSes = () => {
  const element = document.getElementById('smses-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <SMSesComponent />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_SMSES', lazyLoadSMSes, false);

const lazyLoadGuideAIAppHandler = (event: any) => {
  const element = document.getElementById('guideai-app-handler-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const guideAIAppHandlerConfig: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <GuideAIAppHandlerComponent {...guideAIAppHandlerConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_GUIDEAI_APP_HANDLER', lazyLoadGuideAIAppHandler, false);

const lazyLoadRabbitSignDocumnets = (event: any) => {
  const element = document.getElementById('rabbit-sign-docs-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const esignDocumnetsConfig: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <ESignDocumentsComponent {...esignDocumnetsConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_RABBIT_SIGN_DOCS', lazyLoadRabbitSignDocumnets, false);

const lazyLoadSignature = (event: any) => {
  const element = document.getElementById('signature-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const signatureConfigProps: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <SignatureComponent {...signatureConfigProps} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_SIGNATURE', lazyLoadSignature, false);

const lazyLoadSystemMessageEdit = (event: any) => {
  const element = document.getElementById('system-message-edit-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const systemMessageEditProps: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <SystemMessageEditComponent {...systemMessageEditProps} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_SYSTEM_MESSAGE_EDIT', lazyLoadSystemMessageEdit, false);

const lazyLoadNotes = (event: any) => {
  const element = document.getElementById('notes-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const notesConfig: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <NotesComponent {...notesConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_NOTES', lazyLoadNotes, false);

const lazyLoadQuickNoteButton = (event: any) => {
  const element = document.getElementById('quick-note-button-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const notesConfig: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <QuickNoteButton {...notesConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_QUICK_NOTE_BUTTON', lazyLoadQuickNoteButton, false);

const lazyLoadNewNoteFromFileModal = (event: any) => {
  const element = document.getElementById('create-note-from-file-root-lazy');

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);

    const notesConfig: any = event.detail;

    if (root) {
      const app = (
        <ConfigProvider theme={themeToken} getPopupContainer={() => element}>
          <AntApp>
            <Provider store={store}>
              <CreateNoteFromFileModal {...notesConfig} />
            </Provider>
          </AntApp>
        </ConfigProvider>
      );

      root.render(app);
    }
  }
};

document.addEventListener('NCM_LAZY_LOAD_REACT_NEW_FILE_NOTE_MODAL', lazyLoadNewNoteFromFileModal, false);
